import React, { Component } from 'react';
import {resolveVariables} from 'functions';
import {CSSInput} from 'library';

class Table extends React.Component {
    static component_name = 'Table';
    constructor(props) {
        super(props);

        this.config = {
            form_components: [
                <CSSInput label={'css'} name={'style'} default={{}} />,
            ],
            can_have_children: true,
        }
    }

    render() {

        return (
            <table className="table" style={this.props.style || {}}>
                {this.props.children}
            </table>
        );
    }
}

export default Table;
